// simple use state => true when need to hide warningBar and enable FileUploadForm
export function hasActiveSubscription(state: Store) {
  return state.auth.company.data?.subscription.is_active ?? false
}
